<div class="container-fluid container-fluid--normal" *ngIf="settings">
    <div>
        <h1>{{ 'settings' | label: 'cvtemplates' | async }}</h1>
    </div>

    <!-- <div class="d-flex"> Alle code-onderdelen voor het gebruik van een tabel naast een setting (zie ook instellingen Ontwikkelingsdoelstellingen)
        <div class="" style="padding-right: 150px;"> -->

    <div class="h2-content">
        <h2>{{ 'general_settings' | label: 'general' | async }}</h2>

        <div class="row">
            <div class="col-12">
                <p class="p--list-group">{{ 'attach_development_objective_to' | label: 'goals' | async }}</p>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="attachCourseToGoals"
                        [(ngModel)]="settings.attachCourseToGoals" [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving" />
                    <label class="form-check-label"
                        for="attachCourseToGoals">{{ 'attach_course' | label: 'goals' | async }}</label>
                </div>

                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="linkCompetences"
                        [(ngModel)]="settings.linkCompetences" [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving" (change)="linkCompetencesChanged()" />
                    <label class="form-check-label"
                        for="linkCompetences">{{ 'attach_competence' | label: 'goals' | async }}</label>
                </div>

                <div class="form-check form-check--sub-2">
                    <input class="form-check-input" type="radio" id="developmentObjectivesLinkSkills1"
                        name="developmentObjectivesLinkSkills" [(ngModel)]="settings.developmentObjectivesLinkSkills"
                        [ngModelOptions]="{ standalone: true }" [value]="2"
                        [disabled]="saving || !settings.linkCompetences" />
                    <label
                        for="developmentObjectivesLinkSkills1">{{ 'based_on_function' | label: 'goals' | async }}</label>
                </div>

                <div class="form-check form-check--sub-2"
                    [ngClass]="{'active-panel-link': settings.developmentObjectivesLinkSkills == 1}">
                    <input class="form-check-input" type="radio" id="developmentObjectivesLinkSkills2"
                        name="developmentObjectivesLinkSkills" [(ngModel)]="settings.developmentObjectivesLinkSkills"
                        [ngModelOptions]="{ standalone: true }" [value]="1"
                        [disabled]="saving || !settings.linkCompetences" />
                    <label
                        for="developmentObjectivesLinkSkills2">{{ 'based_on_cluster' | label: 'goals' | async }}</label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <p class="p--list-group">{{ 'dev_goal_rights_info' | label: 'goals' | async }}</p>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="radio" id="devGoalsOutsideActiveGoalYearEditable"
                        [(ngModel)]="settings.devGoalsOutsideActiveGoalYearEditable"
                        [ngModelOptions]="{ standalone: true }" [disabled]="saving" [value]="false"
                        (change)="goalRightsChanged()" />
                    <label class="form-check-label"
                        for="devGoalsOutsideActiveGoalYearEditable">{{ 'dev_goal_rights_editable_currrent_year' | label: 'goals' | async }}</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="radio" id="devGoalsOutsideActiveGoalYearEditable1"
                        [(ngModel)]="settings.devGoalsOutsideActiveGoalYearEditable"
                        [ngModelOptions]="{ standalone: true }" [disabled]="saving" [value]="true"
                        (change)="goalRightsChanged()" />
                    <label class="form-check-label"
                        for="devGoalsOutsideActiveGoalYearEditable1">{{ 'dev_goal_rights_editable_all_years' | label: 'goals' | async }}</label>
                </div>

                <div class="form-check form-check--sub-2">
                    <input class="form-check-input" type="radio" id="devGoalsOutsideActiveGoalYearEditableIfNotFinished"
                        name="devGoalsOutsideActiveGoalYearEditableIfNotFinished"
                        [(ngModel)]="settings.devGoalsOutsideActiveGoalYearEditableIfNotFinished"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving || !settings.devGoalsOutsideActiveGoalYearEditable" [value]="true" />
                    <label class="form-check-label"
                        for="devGoalsOutsideActiveGoalYearEditableIfNotFinished">{{ 'dev_goal_rights_only_open' | label: 'goals' | async }}</label>
                </div>
                <div class="form-check form-check--sub-2">
                    <input class="form-check-input" type="radio"
                        id="devGoalsOutsideActiveGoalYearEditableIfNotFinished1"
                        name="devGoalsOutsideActiveGoalYearEditableIfNotFinished"
                        [(ngModel)]="settings.devGoalsOutsideActiveGoalYearEditableIfNotFinished"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving || !settings.devGoalsOutsideActiveGoalYearEditable" [value]="false" />
                    <label class="form-check-label"
                        for="devGoalsOutsideActiveGoalYearEditableIfNotFinished1">{{ 'dev_goal_rights_all' | label: 'goals' | async }}</label>
                </div>
            </div>
        </div>
    </div>

    <div class="h2-content">
        <h2>{{ 'rights_new_employees' | label: 'goals' | async }}</h2>

        <div class="row">
            <div class="col-12">
                <p class="p--list-group">{{ 'development_rights_new_employees' | label: 'goals' | async }}</p>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="allowDevelopmentGoalsCreate"
                        [(ngModel)]="settings.allowDevelopmentGoalsCreate" [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving" />
                    <label class="form-check-label"
                        for="allowDevelopmentGoalsCreate">{{ 'allow_development_goals_create' | label: 'goals' | async }}</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="allowDevelopmentGoalsEdit"
                        [(ngModel)]="settings.allowDevelopmentGoalsEdit" [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving" />
                    <label class="form-check-label"
                        for="allowDevelopmentGoalsEdit">{{ 'allow_development_goals_edit' | label: 'goals' | async }}</label>
                </div>
                <div class="form-check form-check--sub-1">
                    <input class="form-check-input" type="checkbox" id="allowDevelopmentGoalsDelete"
                        [(ngModel)]="settings.allowDevelopmentGoalsDelete" [ngModelOptions]="{ standalone: true }"
                        [disabled]="saving" />
                    <label class="form-check-label"
                        for="allowDevelopmentGoalsDelete">{{ 'allow_development_goals_delete' | label: 'goals' | async }}</label>
                </div>
            </div>
        </div>
    </div>

    <input type="button" class="save-page btn btn-progreso" (click)="saveSettings()"
        value="{{ 'save' | label: 'general' | async }}" [disabled]="saving" />
    <!-- </div> -->

    <!-- <div class="active-panel"
            *ngIf="settings">
            <p>{{ 'select_linkable_clusters' | label: 'goals' | async }}</p>
            <table class="table table-details table-details--widget">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ 'code' | label: 'general' | async }}</th>
                        <th>{{ 'name' | label: 'general' | async }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cluster of clusters; let i = index">
                        <td class="cursor-pointer" (click)="selectCluster(cluster)">
                            <input class="form-check-input" type="checkbox" id="cluster{{i}}" [disabled]="saving"
                                [checked]="clusterSelected(cluster)" />
                        </td>
                        <td class="cursor-pointer" (click)="selectCluster(cluster)">
                            <div class="d-flex align-items-center">
                                <div class="color-circle" [style.background]="cluster.color"></div>
                                <div>{{cluster.code}}</div>
                            </div>
                        </td>
                        <td class="cursor-pointer" (click)="selectCluster(cluster)">{{cluster.name}}</td>
                    </tr>
                </tbody>
            </table>
        </div> -->
    <!-- </div> -->
</div>